import { StudentExtraInfo } from './student-extrainfo.model';

export class Student {

    studentId   : number;
    tutorId     : number;
    tutorName   : string;
    tutorSurname: string;
    tutorPhone  : string;
    tutorMail   : string;
    dni         : string;
    name        : string;
    surname     : string;
    birthDate   : Date;
    genderId    : number;
    genderName  : string;
    school      : string;
    location    : string;
    province    : string;
    postalCode  : string;
    enabled     : boolean;

    extraInfos: StudentExtraInfo[];

}
